import React from 'react'
import {AiOutlineHome, AiOutlineSearch,AiOutlineShoppingCart} from 'react-icons/ai'
// import './css/style.css';
import styled from "styled-components";
import {mobile,tablate} from "../responsive"
import {Link} from "react-router-dom"

const NavContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    width: 100%;
    top: 0%;
    z-index: 1000;
`
// const AiOutlineHomeLogo = styled.div`
    
// `
const Navbars = styled.div`
    
    width: 100%;
    height: 60px;
    background-color:#fff;
    color: #000;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 5px 5px 5px 5px rgba(0,0,0,0.05);
    ${mobile({height:"50px"})}
`
const Search = styled.div`
     font-size: 25px;
    position: relative;
    ${mobile({fontSize:"18px",display:"none"})};
    ${tablate({fontSize:"18px",display:"none"})};
`
const Input = styled.input`
       margin: 0 10px;
    padding: 8px 20px;  
   border-radius: 10px; 
   border: 1px  solid rgb(92, 87, 87);
   outline: none;
   ${mobile({margin:"0 5px",padding:"8px"})};
   ${tablate({margin:"0 5px",padding:"8px",width:"80px"})};

`
const HomeIcon = styled.span`
    display: none;
    ${mobile({display:"block"})};
`
const Logo = styled.div`
    font-size: 40px;
    font-weight: 700;
    text-transform: uppercase;
    ${mobile({fontSize:"20px",fontWeigth:"700",marginLeft:"10px"})};
    ${tablate({fontSize:"20px",fontWeigth:"700"})};
    display: flex;
    justify-content: center;
    align-items: center;
    color: #000;
`
const Span = styled.span`
    margin: 0 5px;
    ${mobile({marginLeft:"2.5px"})};
 `
const ClassIcon = styled.span`
     position: absolute;
    top: 9px;
    right: 20px;
    font-size: 20px;
`
const Links = styled.div`
   display:flex ;
   justify-content: center;
   align-items: center;
   text-transform: uppercase;
   cursor: pointer;

`
const Button = styled.button`
   margin:0 5px ;
   text-transform: uppercase;
   background-color: transparent;
   /* border: 1px solid teal; */
   border: none;
   color: #000;
   font-size: 18px;
   padding: 2px 8px;
   
   ${mobile({fontSize:"14px",margin:"0 10px"})}
   &:hover{
    color: #fff;
    background-color: teal;
}
`
const ShopingCart = styled.div`
    position: relative;
`
const CartIcon = styled.span`
    margin:0 20px ;
   text-decoration: none;
   color: #000;
   font-size: 20px;
`
const CartItemCount = styled.div`
    position: absolute;
    top: -8px;
    right: 15px;
    background-color: blue;
    color: aliceblue;
    width:15px;
    height: 15px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
`

const Home = styled.span`
     ${mobile({display:"none"})}
`
const Navbar = () => {
  return (
    <>
        <NavContainer>
            <Navbars>
                <Search>
                    <Input type="text" placeholder='search...'/>
                    <ClassIcon><AiOutlineSearch /></ClassIcon> 
                </Search>
                <Logo>
                    <Span>
                        <HomeIcon>
                            <AiOutlineHome style={{color:"#000",marginTop:"5px"}}/>
                        </HomeIcon>
                    </Span>             
                    <Span>v-shop</Span>
                </Logo>
                <Links>
                   <Home><Link to="/"><Button>Home</Button></Link></Home>
                    <Link to="/register"><Button>Register</Button></Link>
                    <Link to="/login"><Button >Login</Button></Link>
                    
                    
                    
                    <ShopingCart>
                       <Link to="/cart"> <CartIcon><AiOutlineShoppingCart/></CartIcon>   </Link>                    
                        <CartItemCount>1</CartItemCount>
                     </ShopingCart>
                </Links>
            </Navbars>
        </NavContainer>
    </>
  )
}

export default Navbar